module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAAAAACreq1xAAAAAmJLR0QA/4ePzL8AAACbSURBVFjD7ZhLCoAgFEXdUyvKBSutqEgn1SDupbQPRxAHDw+9dzkEhuHmFQACBPgocL64egDH9RhLKSexwd2tI3B/qsDjrZbA8vGxlKbstRxPQ/FmKKTstaylbAC1lI0ZaikbM9RSdluOfULZlIwZ4jIu4zIu/9flXGcobSnlVGcobVzGZVzmv4zLuIzLbV1+66sIb18AAX4auABcy/ETrwA+owAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/movie.png
// module id = 873
// module chunks = 0